























import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
import { IButtonToggleItem } from './ButtonToggle.type'

@Component({
  model: {
    prop: 'checked',
    event: 'change'
  }
})
export default class ButtonToggle extends ComponentVue {
  @Prop({
    type: Array
  })
  items!: IButtonToggleItem[]

  @Prop({ type: [String, Number, Boolean, Array] })
  checked!: string | number | boolean | []

  @Prop({
    type: Boolean,
    default: false
  })
  mandatory!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  primaryColor!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  // 使用箇所が限られている為、固定のstyle設定の切り替えで十分と判断
  // 柔軟に使用したい場合はその時模索する
  @Prop({
    type: Boolean,
    default: false
  })
  small!: boolean

  get classes(): object {
    return {
      'primary-color': this.primaryColor
    }
  }

  get styles(): object {
    // 資料の管理：検索のサイドバーに合わせた設定
    // 仕様を変更する際は上記を考慮する必要がある
    if (this.small) {
      return {
        'min-width': '44px',
        padding: '0px',
        'font-size': '12px'
      }
    }

    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get internalValue(): string | number | boolean | [] {
    return this.checked
  }

  set internalValue(newVal: string | number | boolean | []) {
    if (this.checked !== newVal) this.$emit('change', newVal)
  }

  @Emit('click')
  onClick(): void {}
}
